//
window.onload = (event) => {
 $("body").removeClass("preload");
};
